import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import { Label } from '@mlc/web-ui-toolkit';
import { Link } from 'react-router-dom';
import { ScreenSize } from '../../../../enums';

export const Li = styled.li`
	padding: 0;
	width: 16rem;

	@media (max-width: ${ScreenSize.small}) {
		width: 100%;
	}
`;

export const AnchorLink = styled.a`
	color: ${palette.mlcText};
	display: flex;
	flex: 1;
	height: 100%;
	padding: 0.5rem 1.5rem;
	text-decoration: none;

	&:focus,
	&:hover {
		color: ${palette.mlcAqua};
		text-decoration: underline;
	}

	@media (max-width: ${ScreenSize.medium}) {
		padding-bottom: 0.35rem;
		padding-top: 0.35rem;
	}

	@media (max-width: ${ScreenSize.small}) {
		padding-bottom: 0.25rem;
		padding-top: 0.25rem;
	}

	@media (max-width: ${ScreenSize.xSmall}) {
		padding-bottom: 0.15rem;
		padding-top: 0.15rem;
	}
`;

export const RouterLink = styled(Link)`
	color: ${palette.mlcText};
	display: flex;
	flex: 1;
	height: 100%;
	padding: 0.5rem 1.5rem;
	text-decoration: none;

	&:focus,
	&:hover {
		color: ${palette.mlcAqua};
		text-decoration: underline;
	}

	@media (max-width: ${ScreenSize.medium}) {
		padding-bottom: 0.35rem;
		padding-top: 0.35rem;
	}

	@media (max-width: ${ScreenSize.small}) {
		padding-bottom: 0.25rem;
		padding-top: 0.25rem;
	}

	@media (max-width: ${ScreenSize.xSmall}) {
		padding-bottom: 0.15rem;
		padding-top: 0.15rem;
	}
`;

export const LinkText = styled(Label)`
	color: inherit;
	display: flex;
	flex: 1;
	flex-shrink: 0;
	flex-wrap: nowrap;
	margin-bottom: 0;
	margin-top: 0;

	@media (max-width: ${ScreenSize.small}) {
		line-height: 1.8 !important;
	}
`;
